export const getConfig = () => {
  const config = {
    environment: process.env.NODE_ENV,
    baseURL: process.env.REACT_APP_BASE_URL,
    GoogleOAuthID: process.env.REACT_APP_GOOGLE_OAUTH_ID,
  };
  return config;
};
